var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainGirl = function SvgMainGirl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "171px",
    height: "223px",
    viewBox: "0 0 171 223",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 43")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2FE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB78D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-5.24892196%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B6F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD084",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB78D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD084",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD084",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7293AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5A75",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87ACC7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7496",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0012956%",
    y1: "-0.00023030368%",
    x2: "50.0012956%",
    y2: "100.002983%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB78D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7293AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5A75",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7293AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5A75",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.4957885%",
    y1: "-163.722269%",
    x2: "-19.9686797%",
    y2: "235.630768%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B6F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.1098754%",
    y1: "12.3631932%",
    x2: "35.8179173%",
    y2: "78.4388696%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDCFA",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1387DD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd6b9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb93",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_login_page",
    transform: "translate(-103.000000, -143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(103.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 51.359961)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.917966,46.7184271 C148.69742,23.2261788 125.760486,5.73598268 97.5546294,1.62724412 C50.9614758,-5.15968072 7.68854444,27.1104598 0.901619608,73.7036134 C-5.88530523,120.296038 26.3841065,163.569698 72.9772601,170.356623 C119.571142,177.143548 162.844074,144.874136 169.630999,98.2802539 C172.262544,80.2114239 169.000623,62.6534533 161.326799,47.5171461 L160.917966,46.7184271 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.7447314,104.590862 C52.3668131,95.2540127 61.7036627,94.22865 64.9488229,91.932333 C70.6834209,87.8738788 68.3492085,62.9780422 68.3492085,62.9780422 L95.1215974,74.6396304 C95.1215974,74.6396304 93.9752608,86.7268134 98.2100745,87.8738788 C106.108356,90.012784 116.913653,115.400532 116.913653,115.400532 L115.54213,132.822225 L73.3674373,144.265915 L51.9091529,137.280039 L42.9942542,134.810277 C42.9942542,134.810277 35.7270778,115.637379 44.7447314,104.590862",
    id: "Fill-4",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.270727,182.08052 C107.968292,169.168383 110.561214,161.469782 110.561214,161.469782 L110.56923,161.474883 C110.717168,159.575739 112.98725,155.199546 112.98725,155.199546 C114.299743,151.633004 115.34041,148.621775 116.145688,146.023752 C119.746482,151.110484 123.510518,155.833566 126.62523,158.424301 C124.688191,165.130334 114.739184,175.71919 108.270727,182.08052 M142.202436,151.590736 C140.806135,147.172275 127.93991,119.460517 123.4974,108.860729 C121.197439,103.371723 118.188397,99.1981248 114.750116,95.9850301 C111.929822,92.9978503 108.702152,91.0659124 105.471567,89.7971444 C105.062733,89.6076673 104.652442,89.421834 104.239237,89.2462033 C104.239237,89.2462033 104.250897,89.2840987 104.269116,89.352602 C102.193612,88.638419 100.137786,88.1793013 98.2094915,87.8732229 C105.796593,106.57753 105.002975,111.341422 99.8863641,113.900092 C85.6814098,120.164497 76.1528967,104.283399 64.9482399,91.9316771 C44.6559686,93.6967294 36.0544359,108.650847 34.2012039,113.944546 C31.7737105,121.045566 27.8347725,146.170961 27.4733085,156.879334 C27.2626974,163.124792 32.576802,162.083396 37.0433608,160.131782 C42.7859752,149.466406 47.390998,138.364504 47.390998,138.364504 C47.390998,138.364504 62.3895699,161.278118 52.6846974,179.805337 C47.9076876,190.131841 44.8556484,200.55454 43.1343216,211.491742 C52.1031484,216.591592 62.1527235,220.139916 72.9776974,221.716948 C87.018681,223.761844 100.756501,222.255501 113.286769,217.88368 C112.093063,210.316256 110.986808,203.722452 110.068573,198.495798 C132.140472,179.118847 136.053175,174.419814 140.127661,166.708095 C144.022145,159.337435 143.598008,156.009925 142.202436,151.590736",
    id: "Fill-6",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFCFB3",
    points: "64.5956667 42.7018036 59.3901471 55.670784 62.7934477 60.4711141 66.8205654 64.2482676 71.0364314 61.1408428 71.7418693 49.4952873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9478931,13.8491016 C73.9478931,13.8491016 92.3825598,-3.13898007 105.366844,21.6045461 C113.788374,37.654716 102.53489,62.2976735 102.53489,62.2976735 L94.7269748,38.6982977 C94.7269748,38.6982977 82.856233,33.0387618 73.9478931,13.8491016",
    id: "Fill-10",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2692598,36.2497431 C66.9921879,31.2876288 71.858835,23.1167922 87.0454265,31.9777627 C91.9565278,34.8432399 96.301384,38.6058183 99.6325376,42.4631353 C104.224443,48.0592693 103.327342,57.4945013 100.205342,65.3760209 C99.9786977,65.8846941 99.7411225,66.4152301 99.4882435,66.963985 C98.8673415,68.3085438 98.1597173,69.7507562 97.3449657,71.1703771 L97.3435082,71.1725634 L97.3435082,71.1725634 C94.8365801,75.5392824 91.3035605,79.6866451 86.0783644,80.1085961 C74.8598611,81.0137137 66.8063546,64.2581059 66.2131454,62.3152366 C65.620665,60.3723673 65.5463317,41.2118575 66.2692598,36.2497431",
    id: "Fill-12",
    fill: "#FFAF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0710356,34.4567794 C65.883601,29.4902925 71.2436173,21.2961356 87.8133918,30.0907892 C93.1726794,32.9351324 97.90815,36.6794918 101.534451,40.5229624 C106.532274,46.1001487 105.508369,55.5412108 102.058428,63.4380343 C101.809192,63.948165 101.54684,64.4794297 101.266996,65.0296422 C100.582692,66.377116 99.8021925,67.8229722 98.9043624,69.2462369 L98.9036337,69.2484232 L98.9029049,69.2484232 C96.1416402,73.627531 92.2588167,77.7909265 86.5417088,78.2361977 C74.267235,79.1923284 65.5337971,62.4687859 64.8939474,60.5281029 C64.2540977,58.5874199 64.2584703,39.4232663 65.0710356,34.4567794",
    id: "Fill-14",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0834618,13.4973301 C84.0834618,13.4973301 84.6088964,0.448915033 72.9939487,0.00583006536 C61.379001,-0.43798366 59.3843899,25.7936667 77.1289225,25.3542255 C94.8734552,24.9140556 84.0834618,13.4973301 84.0834618,13.4973301",
    id: "Fill-16",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.119033,18.4627239 C88.119033,18.4627239 88.875484,38.8213121 67.353069,46.6073644 C67.353069,46.6073644 55.8488925,53.8300866 66.8203467,64.2476846 C66.8203467,64.2476846 50.2432846,51.2641291 50.5493631,32.7908382 C50.8066147,17.2916095 77.9054873,-6.18606373 88.119033,18.4627239",
    id: "Fill-18",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9056173,68.0687095 C69.9056173,68.0687095 71.2909866,77.8238663 66.8120389,83.409069 C65.7429507,84.4686833 64.482199,90.4998859 64.482199,90.4998859 L61.1401141,103.154043 L54.1651696,99.2041735 L64.2898069,69.182252 L69.9056173,68.0687095 Z",
    id: "Fill-20",
    fill: "#FFAF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1887418,66.6563033 C71.049549,65.9450353 65.6545523,38.5225941 65.4643464,37.4535059 C65.3951144,37.0621627 65.2741405,36.8275026 65.1283889,36.6985124 L65.1283889,36.6963261 L65.1240163,36.6934111 C65.1006961,36.6730059 65.0744608,36.6620745 65.049683,36.6467706 L64.248049,36.1475712 L64.383598,36.7050712 C64.3449739,36.7283915 64.3056209,36.7502542 64.2684542,36.7772183 C63.8311993,37.0934993 56.0742974,43.552483 55.301085,44.1529797 C54.5278725,44.7534765 54.5460915,45.2395582 54.6043922,45.7802967 C54.6619641,46.3210353 56.3934935,55.1528556 56.3934935,55.1528556 L62.6367647,75.4276366 C62.6367647,75.4276366 70.0373039,69.0801529 70.6341569,68.5241105 C71.2317386,67.968068 71.3279346,67.3675712 71.1887418,66.6563033",
    id: "Fill-22",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6650268,54.6974546 C55.6650268,54.6974546 53.9327686,45.8656343 53.8751967,45.3248958 C53.8176248,44.7841572 53.7986771,44.2973467 54.5718895,43.6975788 C55.345102,43.097082 63.1020039,36.6380984 63.5399876,36.3218173 C63.9772425,36.0055363 64.5456739,35.9282879 64.7358797,36.9973761 C64.9260856,38.0671931 70.3210824,65.4896343 70.4602752,66.2009023 C70.599468,66.9121703 70.5025431,67.512667 69.9056902,68.0687095 C69.3088373,68.624752 61.908298,74.9722356 61.908298,74.9722356 L55.6650268,54.6974546 Z",
    id: "Fill-24",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8535742,60.2035141 C63.4091755,60.1903964 63.3661788,60.2348507 60.0933258,60.9563212 C60.0933258,60.9563212 60.4970578,59.9120108 60.6566559,58.8728016 C61.6616134,58.3940075 62.6804173,57.0144683 62.6804173,57.0144683 C62.6804173,57.0144683 65.3381984,56.6879846 66.2017768,55.7391415 C67.0653552,54.7910271 66.6995186,54.0236448 65.7834696,53.7707657 C64.8608618,53.5157003 63.1810742,54.0965206 61.9108487,54.3180631 C60.8832997,54.4980663 58.4106232,56.3491121 58.4106232,56.3491121 C58.4106232,56.3491121 58.9440742,52.3795663 58.9127376,50.9971121 C58.881401,49.6146578 59.2807605,47.6207755 58.0200088,47.3453049 C56.7592572,47.0698343 56.274633,48.7314029 56.2607866,49.4900402 C56.247669,50.2494062 55.8410219,54.3515859 55.4088683,55.9133147 C54.9752572,57.4743147 55.1428716,58.9121546 56.5362572,63.0879389 C56.0363291,65.2924324 56.2724467,67.4320663 56.2724467,67.4320663 C56.2724467,67.4320663 55.6675775,69.8355108 56.4079958,72.890465 C57.1484141,75.9454193 57.700084,83.1018245 54.9001951,90.2859225 C52.1003062,97.4707493 61.9239663,95.2830173 61.9239663,95.2830173 L63.4222931,93.7839618 C63.4222931,93.7839618 65.1115546,88.4057265 65.6763422,86.270465 C65.7266265,86.0795304 65.7637931,85.8900533 65.7914859,85.7027624 C65.9022572,85.4804912 66.0071984,85.2348997 66.1012082,84.9346513 C68.1657801,78.3146121 61.6346493,69.6307297 61.6346493,69.6307297 C61.9684206,68.9034291 63.4011592,68.3830958 63.4011592,68.3830958 C63.4011592,68.3830958 64.2487049,71.0933474 66.2156232,70.4352788 C67.0908618,70.0322755 66.0698716,67.2739258 66.0698716,67.2739258 L65.6333454,66.5254912 C65.5218454,66.3804683 65.4314794,66.2485631 65.3454859,66.1305042 C65.215767,65.9847526 65.0671003,65.8382722 64.8943846,65.6961644 C64.5926788,65.531465 64.1306461,65.4768082 63.2211559,65.5686317 C61.4284108,65.7500925 61.4094631,65.775599 60.9569042,65.9847526 C61.6346493,65.0002003 61.6200742,63.6141023 61.6200742,63.6141023 C62.8677082,63.7598539 65.4045154,62.8860729 65.4045154,62.8860729 C65.4045154,62.8860729 68.6904859,63.5310239 69.2100905,62.1995827 C69.9096984,60.4082951 66.0246886,60.2137167 64.8535742,60.2035141",
    id: "Fill-26",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2064271,55.7881869 C59.2064271,55.7881869 58.122035,56.5220464 57.9172539,56.6699843 C57.7124729,56.818651 57.4085807,57.6661967 57.0653356,60.5222 C57.7678585,57.1750137 57.6446984,56.8055333 59.2064271,55.7881869",
    id: "Fill-28",
    fill: "#FFAF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0933258,60.9567585 C60.0933258,60.9567585 59.0482866,61.7562062 58.5906265,62.2554056 C58.1329663,62.7546049 57.9252703,64.7368271 57.9252703,64.7368271 C57.9252703,64.7368271 58.0360415,62.6022944 58.2991232,62.2138663 C58.5629337,61.8254382 59.2807605,61.2803271 60.0933258,60.9567585",
    id: "Fill-30",
    fill: "#FFAF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.904148,39.6480154 C63.8706252,38.9491363 63.5273801,38.3974663 63.1374944,38.4156853 C62.7476088,38.4339042 62.4582918,39.016182 62.4910859,39.7150611 C62.5246088,40.4139402 62.8678539,40.9663389 63.2577395,40.9473912 C63.6476252,40.9291722 63.9376709,40.3468944 63.904148,39.6480154",
    id: "Fill-32",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.748631,41.6802304 C63.3587454,41.6984493 63.0694284,42.2807271 63.1022225,42.9796062 C63.1357454,43.6784853 63.4789905,44.230884 63.8688761,44.2119363 C64.2594905,44.1937173 64.5488075,43.6114395 64.5152846,42.9125605 C64.4824905,42.2136814 64.1392454,41.6620114 63.748631,41.6802304",
    id: "Fill-34",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7024278,93.4214775 C63.7024278,93.4214775 58.6929441,95.122399 54.7751402,90.7338173 C48.1937252,106.861964 34.7459507,139.174373 31.8768297,145.406713 C29.0077088,151.639053 25.7640062,157.664425 28.1703657,162.197301 C30.5767252,166.730177 33.4086794,169.399618 37.9255225,169.956389 C42.4416369,170.513889 47.1734637,167.096013 48.9326859,162.768647 C50.6919082,158.441281 58.5901892,130.479559 63.7024278,93.4214775",
    id: "Fill-36",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.561505,161.54652 C113.365038,150.564134 123.464897,144.331794 114.224973,123.165013 C115.514146,128.967386 118.204721,136.271729 116.91409,142.946425 C115.622731,149.621121 110.383688,157.201664 110.561505,160.150948 C110.645312,161.544334 110.561505,161.54652 110.561505,161.54652",
    id: "Fill-38",
    fill: "#5DA4E5",
    opacity: 0.316590607
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.270727,182.08052 C108.270727,182.08052 108.082707,187.439079 110.068573,198.495798 C113.877063,195.158814 121.437929,188.235612 121.437929,188.235612 L119.16056,170.289942 L108.270727,182.08052 Z",
    id: "Fill-40",
    fill: "url(#linearGradient-14)",
    opacity: 0.451427641
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainGirl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main_girl.fa3f3949.svg";
export { ForwardRef as ReactComponent };